import { render, staticRenderFns } from "./DesigningPage.vue?vue&type=template&id=325e3934&"
import script from "./DesigningPage.vue?vue&type=script&lang=ts&"
export * from "./DesigningPage.vue?vue&type=script&lang=ts&"
import style0 from "./DesigningPage.vue?vue&type=style&index=0&id=325e3934&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports